import * as React from 'react';
import c from 'classnames';

import {
  LinkField,
} from '@uncinc/react-drupal-core/types';
import { Button, Container, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

type Props = {
  media: React.ReactElement
  title: string,
  body: string,
  button?: LinkField;
  background?: 'primary' | 'secondary'
  containMedia?: boolean
};

const Hero: React.FC<Props> = (props) => {
  const {
    media,
    title,
    body,
    button,
    background = 'primary',
    containMedia = false,
  } = props;

  const classes = c('Hero', `Hero--background-${background}`);
  const mediaClasses = c('Hero__media', {
    'Hero__media--contained': containMedia,
  });

  return (
    <Container>
      <div className={classes}>
        <div className="Hero__inner">
          <div className={mediaClasses}>
            {media}
          </div>
          <div className="Hero__content">
            <h1>{title}</h1>
            <WysiwygField
              className="body--large"
              property="schema:text"
              html={body}
            />
            {button && (
              <div className="Hero__content__button">
                <Button className="w-auto" href={button.alias || button.uri}>{button.title}</Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </Container>
  );
};

export default Hero;
